'use strict';

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('lazysizes');

require('lazysizes/plugins/unveilhooks/ls.unveilhooks');

require('lazysizes/plugins/bgset/ls.bgset');

require('lazysizes/plugins/parent-fit/ls.parent-fit');

require('remodal/dist/remodal');

require('../../styles/theme.scss');

require('../../styles/theme.scss.liquid');

require('../modules/cart');

require('../modules/accordian');

var _Sliders = require('../modules/Sliders');

var _Sliders2 = _interopRequireDefault(_Sliders);

var _filter = require('../modules/filter');

var _filter2 = _interopRequireDefault(_filter);

var _productForm = require('../modules/productForm');

var _productForm2 = _interopRequireDefault(_productForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Product Custom */

(0, _Sliders2.default)();
(0, _filter2.default)();
(0, _productForm2.default)();

window.Sliders.init();
window.Filters.init();
window.ProductForm.init();